/* Visivio — karuzela wyników i opinii.
   Przewijanie robi natywny scroll ze snapowaniem, więc palec na telefonie
   działa tak, jak się spodziewa, a strzałki i kropki tylko go popychają.
   Autoprzesuwanie zatrzymuje się przy pierwszym dotknięciu, najechaniu
   kursorem, fokusie z klawiatury i poza widokiem — i nie startuje wcale
   przy prefers-reduced-motion. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function slidesOf(track) {
    return Array.prototype.slice.call(track.querySelectorAll('.vv-slide'));
  }

  function setup(car) {
    if (car.getAttribute('data-vv-bound')) return;
    car.setAttribute('data-vv-bound', '1');

    var track = car.querySelector('.vv-car__track');
    var prev = car.querySelector('[data-vv-prev]');
    var next = car.querySelector('[data-vv-next]');
    var dotsBox = car.querySelector('[data-vv-dots]');
    if (!track) return;

    var slides = slidesOf(track);
    if (!slides.length) return;

    /* kropki */
    var dots = [];
    if (dotsBox) {
      dotsBox.innerHTML = '';
      slides.forEach(function (sl, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'vv-car__dot';
        d.setAttribute('aria-label', 'Przejdź do kafelka ' + (i + 1));
        d.addEventListener('click', function () { stop(); go(i); });
        dotsBox.appendChild(d);
        dots.push(d);
      });
    }

    function current() {
      var mid = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestD = Infinity;
      slides.forEach(function (sl, i) {
        var c = sl.offsetLeft + sl.offsetWidth / 2;
        var d = Math.abs(c - mid);
        if (d < bestD) { bestD = d; best = i; }
      });
      return best;
    }

    function go(i) {
      var n = Math.max(0, Math.min(i, slides.length - 1));
      track.scrollTo({ left: slides[n].offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function sync() {
      var i = current();
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      var atStart = track.scrollLeft <= 2;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;
    }

    if (prev) prev.addEventListener('click', function () { stop(); go(current() - 1); });
    if (next) next.addEventListener('click', function () { stop(); go(current() + 1); });

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); stop(); go(current() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); stop(); go(current() - 1); }
    });

    var tick = null;
    track.addEventListener('scroll', function () {
      if (tick) return;
      tick = requestAnimationFrame(function () { tick = null; sync(); });
    }, { passive: true });
    window.addEventListener('resize', sync);
    sync();

    /* autoprzesuwanie */
    var timer = null, stopped = false;
    var wants = car.getAttribute('data-autoplay') === 'true' && !reduce && slides.length > 1;
    var every = (parseInt(car.getAttribute('data-interval'), 10) || 5) * 1000;
    var visible = true;

    function stop() {
      stopped = true;
      if (timer) { clearInterval(timer); timer = null; }
    }
    function start() {
      if (!wants || stopped || timer) return;
      timer = setInterval(function () {
        if (!visible || document.hidden) return;
        var i = current();
        go(i >= slides.length - 1 ? 0 : i + 1);
      }, every);
    }

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      track.addEventListener(ev, stop, { passive: true });
    });
    car.addEventListener('pointerenter', function () { if (timer) { clearInterval(timer); timer = null; } });
    car.addEventListener('pointerleave', function () { start(); });
    car.addEventListener('focusin', stop);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        visible = en[0].isIntersecting;
      }, { threshold: 0.25 }).observe(car);
    }
    start();
  }

  /* lightbox — jeden na stronę, obsługuje każdy [data-vv-lb] */
  function lightbox() {
    var lb = document.querySelector('[data-vv-lightbox]');
    if (!lb || lb.getAttribute('data-vv-bound')) return;
    lb.setAttribute('data-vv-bound', '1');
    var img = lb.querySelector('[data-vv-lb-img]');
    var x = lb.querySelector('[data-vv-lb-close]');
    var last = null;

    function open(src, label) {
      last = document.activeElement;
      img.src = src;
      img.alt = label || 'Zrzut ekranu';
      lb.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      x.focus();
    }
    function close() {
      lb.setAttribute('data-open', 'false');
      img.src = '';
      document.body.style.overflow = '';
      if (last && last.focus) last.focus();
    }
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-vv-lb]') : null;
      if (t) open(t.getAttribute('data-vv-lb'), t.getAttribute('aria-label'));
    });
    x.addEventListener('click', close);
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (lb.getAttribute('data-open') !== 'true') return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'Tab') { e.preventDefault(); x.focus(); }
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-vv-car]'), setup);
    lightbox();
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
